/**
 * The user's own choice of My tasks version. Delete this file with the flag, together with
 * its only outside reader, utils/survicate.function.ts.
 */

export const BETA_STORAGE_KEY = '@@myTasks/beta';

/**
 * the version the user picked with the Beta switch; null = never picked one
 */
export function readStoredBeta(storage: Storage = window.localStorage): boolean | null {
    try {
        const raw = storage.getItem(BETA_STORAGE_KEY);
        if (raw === 'true') return true;
        if (raw === 'false') return false;
        return null;
    } catch (e) {
        return null;
    }
}

/**
 * the new version is the default; only an explicit switch-off keeps the old list
 */
export function isBetaEnabled(storage: Storage = window.localStorage): boolean {
    return readStoredBeta(storage) !== false;
}

export function writeStoredBeta(enabled: boolean, storage: Storage = window.localStorage): void {
    try {
        storage.setItem(BETA_STORAGE_KEY, String(enabled));
    } catch (e) {
        // a full or blocked storage must not break the switch
    }
}
